import { render, staticRenderFns } from "./IPPools.vue?vue&type=template&id=145fb880&"
import script from "./IPPools.vue?vue&type=script&lang=js&"
export * from "./IPPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports